export default "static/src/images/Map4.png";